import type { ReactElement } from 'react';

export interface SpinnerProps {
  size?: number;
  /** Announced only when the spinner is the sole indication of progress. */
  label?: string;
}

export function Spinner({ size = 14, label }: SpinnerProps): ReactElement {
  return (
    <span
      className="spinner"
      style={{ width: size, height: size }}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
